import { render, staticRenderFns } from "./customer_seas_detail.vue?vue&type=template&id=1ec36632&"
import script from "./customer_seas_detail.vue?vue&type=script&lang=js&"
export * from "./customer_seas_detail.vue?vue&type=script&lang=js&"
import style0 from "./customer_seas_detail.vue?vue&type=style&index=0&id=1ec36632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports